import React from 'react';
import PropTypes from 'prop-types';
import Body from '../Components/layout/Body';

const INTRO_HELP = `
  <div>
    <p><strong>Purpose:</strong> Everything flows from the client’s goals and activities: what do they want to do that they currently have difficulty doing?  
    Alternative access is a means to an end, a way of achieving something that has value to the client.  Knowing the client’s goals is a foundation for motivation, and helps you choose the tasks in the assessment that relate to those goals. 
    <p>Relative to models of assistive technology, this is the A (Activity) in the HAAT model, and the T (Task) in the SETT model.</p>
  </div>
`;

const propTypes = {
  firstName: PropTypes.string,
  pronouns: PropTypes.array, //[she, her, hers]
  onContinue: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their']
};

//content sub-component with unique content for this page
function GoalsIntroContent(props) {
  const pronouns = props.pronouns;
  let verb = "wants";
  if (pronouns[0] === defaultProps.pronouns[0])
    verb = "want";  
  return(
    <>
    <p>This includes:</p>
    <ul>
        <li>Activities that {pronouns[0]} {verb} to do</li>
        <li>The priority activity to work on first</li>
        <li>Platforms or devices that {pronouns[0]} {verb} to access</li>
    </ul>
    </>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function GatherInfoGoalsIntro(props) {
  const firstName = props.firstName;
  const pronouns = props.pronouns;
  const onContinue = props.onContinue;
  
  console.log("rendering GatherInfoGoalsIntro");

  const pageData = {
    image: "",
    faIcon: "",
    pageSymbolClassName: "aa-section-symbol gather",
    title: `Let's consider ${firstName}'s goals and needs`,
    subTitle: "",
    learnMore: {linkText: "Learn More about why we ask about goals and needs",
                title: "Goals and Needs",
                content: INTRO_HELP
                },
    nextRoute: "", //not used since we have an onContinue callback
    sidebar: false
  }

  return(
    <>
    <Body page={pageData}
      contentComponent={<GoalsIntroContent pronouns={pronouns}/>} 
      onContinue={onContinue}
    />
    </>
  );
}

GatherInfoGoalsIntro.propTypes = propTypes;
GatherInfoGoalsIntro.defaultProps = defaultProps;

export default GatherInfoGoalsIntro;